const MBType = [
  {
    1001: '新築マンション（1部屋）',
    1011: '新築マンション（分譲）',
    1021: '中古マンション（1部屋）',
    1002: '新築タウンハウス（1部屋）',
    1012: '新築タウンハウス（分譲）',
    1022: '中古タウンハウス（1部屋）',
    1101: '新築戸建て（1戸）',
    1111: '新築戸建て（分譲）',
    1121: '中古戸建（1戸）',
    1102: '新築テラスハウス（1戸）',
    1112: '新築テラスハウス（分譲）',
    1122: '中古テラスハウス（1戸）',
    1201: '売地',
    1202: '借地権',
    1203: '底地権',
  },
  {
    2101: '店舗',
    2102: '店舗付住宅',
    2103: '賃貸併用住宅',
    2104: '事務所',
    2105: '店舗事務所',
    2106: 'ビル',
    2107: 'マンション',
    2108: 'アパート',
    2109: '戸建賃貸',
    2110: '倉庫',
    2111: '工場',
    2112: 'ホテル',
    2201: '駐車場',
    2202: '土地',
    2301: '軍用地',
  },
  {
    2001: '店舗',
    2002: '事務所',
    2003: '店舗事務所',
    2004: 'マンション',
  },
]

export default MBType
